import React from "react";
import * as Yup from "yup";
import { Formik, Form, ErrorMessage } from "formik";

import { useAppDispatch } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { addPassword, clearErrorMessage } from "../../../../redux/profile/settings/changePass/slice";
import { fetchSendNewPassword } from "../../../../redux/profile/settings/changePass/asyncActions";
import { changePassSelector } from "../../../../redux/profile/settings/changePass/selectors";

import { Button, PasswordInput } from "../../../../components";

import styles from "./NewPasswordForm.module.scss";

import { ValidMessages } from "../../../../resources/locale";
import { SubmitValueType } from "./types";

type NewPasswordFormProps = {
  handleSubmitForm?: () => void;
};

export const NewPasswordForm: React.FC<NewPasswordFormProps> = (props) => {
  const { handleSubmitForm } = props;
  const dispatch = useAppDispatch();
  const { phone, errorMessage, isLoading } = useSelector(changePassSelector);
  const prevPasswordRef = React.useRef("");
  const prevPasswordRepeatRef = React.useRef("");

  const initialValues = {
    password: "",
    passwordRepeat: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .required(ValidMessages.inputs.password.REQUIRED)
      .min(6, ValidMessages.inputs.password.NOT_FULL),
    passwordRepeat: Yup.string()
      .required(ValidMessages.inputs.passwordRepeat.REQUIRED)
      .oneOf([Yup.ref("password"), null], ValidMessages.inputs.passwordRepeat.NOT_MATCH),
  });

  const handleSubmit = async (values: SubmitValueType) => {
    dispatch(clearErrorMessage());
    
    const data = {
      phone,
      password: values.password,
      passwordRepeat: values.passwordRepeat,
    };

    try {
      await dispatch(fetchSendNewPassword(data)).unwrap();
      handleSubmitForm && handleSubmitForm();
    } catch (error) {
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={true}
    >
      {(formik) => {
        const currentPassword = formik.values.password;
        const currentPasswordRepeat = formik.values.passwordRepeat;
        
        if (errorMessage && 
            (currentPassword !== prevPasswordRef.current || 
             currentPasswordRepeat !== prevPasswordRepeatRef.current)) {
          prevPasswordRef.current = currentPassword;
          prevPasswordRepeatRef.current = currentPasswordRepeat;
          dispatch(clearErrorMessage());
        } else {
          prevPasswordRef.current = currentPassword;
          prevPasswordRepeatRef.current = currentPasswordRepeat;
        }

        return (
          <Form className={styles.form}>
            <div className={styles.formSection}>
              <PasswordInput
                name="password"
                lable="Новый пароль"
                placeholder=""
              />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="password"
              />
            </div>
            <div className={styles.formSection}>
              <PasswordInput
                name="passwordRepeat"
                lable="Повторите пароль"
                placeholder=""
              />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="passwordRepeat"
              />
              {errorMessage && (
                <div className={styles.errorMessage}>
                  {errorMessage}
                </div>
              )}
            </div>
            <Button
              type="submit"
              newStyles={styles.button}
              disabled={formik.isSubmitting || isLoading}
            >
              {isLoading ? "Сохранение..." : "Сохранить и войти"}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
